angular.module('Itao.IndicatorMap').directive('transposedFeatureTable', function (d3, mapConfig) {
  'use strict';

  var identity = d3.hyperion.accessor();
  var accessor = d3.hyperion.accessor;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var numberFormat = germanNumberFormat(',.2f');

  var transposedFeatureTable = function () {
    var indicators = [],
      colorSets = {},
      selectedDistrictKeys = [],
      disabledDistrictKeys = [];

    var table = function (selection) {
      selection.each(function (data) {
        var districtUids = Object.keys(data.districts).filter(function(d) {
          return disabledDistrictKeys.indexOf(data.districts[d].key) === -1;
        });

        var heads = [{key: '', hasNoGeoData: true}].concat(districtUids.map(function(uid){
          return data.districts[uid];
        }));

        var container = d3.select(this).data([data]);

        var thead = container.select('thead');
        var headings = thead.selectAll('tr').data([heads]);

        headings.enter()
          .append('tr');

        var th = headings.selectAll('th')
          .data(heads);


        th.enter()
          .append('th')
          .append('span');

        th
          .style('color', function(d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : 'inherit';
          });

        th.exit().remove();

        th.select('span')
          .html(accessor('key'));

        if (angular.isObject(data)) {
          var bodyData = [];
          for(var i = 0; i < indicators.length; i++) {
            bodyData.push([indicators[i].name].concat(
              districtUids.map(function(uid) {
                var value = data[uid][indicators[i].uid];
                if(value == null) {
                  return '-';
                } else {
                  if(indicators[i].categorical && indicators[i].defaultColorSet && colorSets[indicators[i].defaultColorSet]) {
                    value = '<span class="'+colorSets[indicators[i].defaultColorSet].colors[value].icon+'" style="color:'+colorSets[indicators[i].defaultColorSet].colors[value].color+';"></span>';
                  } else {
                    if(indicators[i].unit === '%') {
                      value = germanNumberFormat(',.'+mapConfig.relativeIndicatorsDecimalPlaces+'f')(value)+'%';
                    } else {
                      value = germanNumberFormat(',.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(value);
                    }
                  }
                }
                return value;
              })
            ));
          }

          var tbody = container.select('tbody');
          var rows = tbody.selectAll('tr').data(bodyData, function (d, i) {
            return i;
          });

          rows.enter()
            .append('tr');

          rows.exit().remove();

          var elements = rows.selectAll('td')
            .data(identity);

          elements.enter()
            .append('td');

          elements.exit().remove();

          elements
            .html(identity);
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    table.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return table;
      }
    };

    /**
     * getter/setter for indicators
     * @param {Object} [newColorSets] set of new colorSets
     * @returns {*}
     */
    table.colorSets = function (newColorSets) {
      if (!arguments.length) {
        return colorSets;
      } else {
        colorSets = newColorSets;
        return table;
      }
    };

    /**
     * getter/setter for selectedDistrictKeys
     * @param {Array} [newSelectedDistrictKeys] set of new selectedDistrictKeys
     * @returns {*}
     */
    table.selectedDistrictKeys = function (newSelectedDistrictKeys) {
      if (!arguments.length) {
        return selectedDistrictKeys;
      } else {
        selectedDistrictKeys = newSelectedDistrictKeys;
        return table;
      }
    };

    /**
     * getter/setter for disabledDistrictKeys
     * @param {Array} [newDisabledDistrictKeys] set of new disabledDistrictKeys
     * @returns {*}
     */
    table.disabledDistrictKeys = function (newDisabledDistrictKeys) {
      if (!arguments.length) {
        return disabledDistrictKeys;
      } else {
        disabledDistrictKeys = newDisabledDistrictKeys;
        return table;
      }
    };

    return table;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'transposedFeatureTable.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      disabledDistrictKeys: '=',
      indicators: '=',
      colorSets: '=',
      config: '='
    },
    link: function (scope, element) {

      scope.config.fullscreen = scope.config.fullscreen || false;
      jQuery(element).find('.table-wrap').on('scroll', function(){
        jQuery(element).find('.table-overlay-wrap').find('table').css({'margin-left': -jQuery(this).scrollLeft()});
      });

      var transposedFeatureTableFunction = transposedFeatureTable();
      d3.select(element[0]).classed('feature-table', true);
      var rerender = function () {
        if(scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        transposedFeatureTableFunction
          .disabledDistrictKeys(scope.disabledDistrictKeys)
          .indicators(scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
          }))
          .selectedDistrictKeys(scope.selectedDistricts.map(function(d) {
            return d.key;
          }))
          .colorSets(scope.colorSets.reduce(function(acc, colorset){
            acc[colorset.uid] = colorset;
            return acc;
          }, {}));


        var elementSelection = d3.select(element.find('.widget-inner:first')[0]);
        elementSelection.selectAll('table')
          .datum(scope.layer)
          .call(transposedFeatureTableFunction);
      };

      scope.fillExportFields = function () {
        // JSON for Table-Export
        scope.indicatorJson = angular.toJson(scope.indicators);
        scope.layerJson = angular.toJson(scope.layer);

        setTimeout(function(){
          scope.indicatorJson = scope.layerJson = '';
        }, 100);
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watch('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        selectedDistrictsWatcher();
        disabledDistrictKeysWatcher();
        fullscreenWatcher();
      });
    }
  };
});
